import toast, { Toaster } from "react-hot-toast";
import { TopInfo } from "../../components/top-info/top-info";
import { useEffect, useState, useRef } from "react";
import { InputIcon } from "../../../components/inputs/input-icon";
import { ButtonIcon } from "../../../components/buttons/button-icon";
import { AiOutlineClose } from "react-icons/ai";
import { HiMagnifyingGlass } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../helpers/constants";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../../services/atoms/auth.atoms";
import { useSelectionProcessAction } from "../../../services/actions/selection-process.actions";
import TableComponent from "../../../components/table/table-component";
import { selectionProcessAtom } from "../../../services/atoms/selection-process.atom";
import {
  HiDotsVertical,
  HiOutlineTrash,
} from "react-icons/hi";
import ColorsCircles from "../params/components/colors-roles";
import { MdArrowForwardIos } from "react-icons/md";
import { includes } from "lodash";

const topInfo = {
  title: "Evaluaciones",
  subtitle: "Módulo de configuración de procesos de evaluación.",
};
const options = [
  {
    id: "opt-2",
    title: "Eliminar Proceso",
    action: "remove",
    icon: HiOutlineTrash,
  },
];

const columns = [
  {
    Header: "ID",
    accessor: ({ code }) => <div>{`PE-${code}`}</div>
  },
  {
    Header: "Cargo",
    accessor: ({ positions }) => <div>{positions[0]?.name}</div>,
  },
  {
    Header: "Competencias",
    accessor: ({ positions }) => (
      <div className="gm-table-competences-selected">
        {positions &&
          positions[0]?.competences.map((skills) => (
            <div key={skills.id}>
              {" "}
              <span> {skills.name}</span>{" "}
              <div>
                {skills.colorType.map((colors) => (
                  <ColorsCircles colors={colors} />
                ))}
              </div>
            </div>
          ))}
      </div>
    ),
  },
  {
    Header: "Acciones",
    accessor: "",
    disableFilters: true,
    disableSortBy: true,
    type: "actions",
  },
];

const initialSearchValue = { name: "", colorType: [] };

const SelectionProcess = () => {
  const user = useRecoilValue(userAtom);
  const navigate = useNavigate();
  const { paginateSelectionProcess, deleteSelectionProcess} = useSelectionProcessAction();
  const selectionProcess = useRecoilValue(selectionProcessAtom);
  const [searchExists, setSearch] = useState("");
  const [searchValues, setSearchValue] = useState(initialSearchValue);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(1000);
  const [selectedSelectionProcess, setSelectedSelectionProces] = useState({});

  const handleCreateView = () => {
    navigate(`${ROUTES.PROCESS.route}/create-view`);
  };

  const handleSearchByName = (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    let form = Object.fromEntries(data.entries());
    let search = { column: "pos.name", value: form["search"] };
    setSearch(form["search"]);
    paginateSelectionProcess({ page, limit, search, clientId: user?.data?.clientId });
  };
  const handleChangeValue = (key, value) =>
    setSearchValue((prevValues) => ({ ...prevValues, [key]: value }));

  const handleCleanSearch = () => {
    setSearch("");
    setSearchValue(initialSearchValue);
    paginateSelectionProcess({ page, limit, clientId: user?.data?.clientId });
  };
  const handleChangePage = (e) => setPage(e + 1);
  const handleSetLimit = (e) => setLimit(e);
  const handleOptionAction = (action, row) => {
    if (action === "remove") {
      setSelectedSelectionProces(row);
      handleDeleteSkill(row, "este proceso de selección");
    }
  };

  const handleConfirm = (toastId, row) => {
    deleteSelectionProcess(row.id, (res) => {
      if (includes(res?.message, "Request failed with status")) {
        toast.error("El perfil profesional no se ha podido eliminar", {
          duration: 4000,
        });
        toast.dismiss(toastId);
      } else {
        toast.success("Proceso de selección eliminado exitosamente", { duration: 4000 });
        toast.dismiss(toastId);
        paginateSelectionProcess({ page, limit, clientId: user?.data?.clientId });
      }
    });
  };

  const handleCancel = (toastId) => {
    toast.dismiss(toastId);
  };

  const handleDeleteSkill = (row, text) => {
    toast(
      (t) => (
        <div className="gm-modal-form-group">
          <p style={{ color: "#003849" }}>
            ¿Estás seguro de que quieres eliminar {text}?
          </p>
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <button
              className="gm-secondary-button"
              onClick={() => handleCancel(t.id)}
            >
              Cancelar
            </button>
            <button
              className="gm-primary-button"
              onClick={() => handleConfirm(t.id, row)}
            >
              Confirmar
            </button>
          </div>
        </div>
      ),
      { duration: 6000 }
    );
  };
  const handleOpenDetails = (e, index) => {
    navigate(`${ROUTES.PROCESS.route}/${e.id}`, { state: { process: e, index: `${index}` } });
  }

  const actions = [
    { icon: HiDotsVertical, dropdown: true },
    { icon: MdArrowForwardIos, action: handleOpenDetails },
  ];

  const isInitialMount = useRef(true);

  useEffect(() => {
    // if (isInitialMount.current) {
    //   isInitialMount.current = false;
    //   return;
    // }

    paginateSelectionProcess({ page, limit, clientId: user?.data?.clientId });
  }, [page, limit]);

  return (
    <div className="gm-selection-process-screen-container">
      <Toaster />
      <TopInfo info={topInfo} />
      <div className="gm-ts-searchbar-container">
        <div className="gm-ts-searchbar-title-container">
          <form onSubmit={(e) => handleSearchByName(e, "name")}>
            <InputIcon
              Icon={HiMagnifyingGlass}
              type="text"
              placeholder="Buscar por nombre"
              name="search"
              value={searchValues.name}
              onChange={(e) => handleChangeValue("name", e.target.value)}
            />
          </form>
          {searchExists && (
            <button
              className="gm-clean-search-button"
              onClick={handleCleanSearch}
              type="button"
            >
              <AiOutlineClose size={18} />
            </button>
          )}
        </div>
        <div className="gm-ts-searchbar-actions-container">
          <ButtonIcon
            buttonLabel="Nueva Evaluación"
            type="button"
            className="gm-primary-button"
            onClick={() => handleCreateView()}
          />
        </div>
      </div>
      <TableComponent
        classNameBody="qs-table-body-params"
        data={selectionProcess?.payload || []}
        loading={selectionProcess.loading}
        emptyListInformer="small"
        columns={columns}
        handleOptionAction={handleOptionAction}
        handleChangePage={handleChangePage}
        handleSetLimit={handleSetLimit}
        controlledPageCount={
          selectionProcess?.total
            ? Math.ceil(selectionProcess.total / limit)
            : 1
        }
        actions={actions}
        options={options}
        section={{ plural: "Procesos", singular: "proceso" }}
        manualPagination={true}
        pagination
      />
    </div>
  );
};

export default SelectionProcess;
